import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'release-conductor',
});

export const opsRouteRef = createRouteRef({
  id: 'release-conductor-ops',
});
